@if (formGroup().value.value?.caregiver) {
    <div class="flex">
        <mds-checkbox
            [attr.data-cy]="'caregiver-checkbox'"
            [label]="label()"
            [formCtrl]="formGroup().controls.checked"
        />
    </div>
}
